export default __webpack_public_path__ + "static/image1-3b830805c8043185a98468458e339a41.jpg";